'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileMenu = exports.CLASS_ACTIVE = exports.CLASS_MENU_OPEN = exports.MOBILE_MENU_SUBMENU_HANDLE = exports.MOBILE_MENU_SUBSUBMENU_BACK = exports.MOBILE_SUBSUBMENU_TOGGLE = exports.MOBILE_MENU_SUBSUBMENU = exports.MOBILE_MENU_SUBMENU_BACK = exports.MOBILE_SUBMENU_TOGGLE = exports.MOBILE_SUBMENU_CONTAINER = exports.MOBILE_MENU_MENU_SELECTOR = exports.MOBILE_MENU_TOGGLE = exports.MOBILE_MENU_SELECTOR = exports.MOBILE_MENU_BACKDROP = exports.MOBILE_MENU_CLOSE = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

var _Header = require('./../../sections/header/Header');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Mobile Menu
 *    Scripts for the mobile menu
 *
 *  Version:
 *    1.0.0 - 2020/03/02
 */

var MOBILE_MENU_CLOSE = exports.MOBILE_MENU_CLOSE = '[data-mobile-menu-close]';
var MOBILE_MENU_BACKDROP = exports.MOBILE_MENU_BACKDROP = '[data-mobile-menu-backdrop]';
var MOBILE_MENU_SELECTOR = exports.MOBILE_MENU_SELECTOR = '[data-mobile-menu]';
var MOBILE_MENU_TOGGLE = exports.MOBILE_MENU_TOGGLE = '[data-mobile-menu-toggle]';
var MOBILE_MENU_MENU_SELECTOR = exports.MOBILE_MENU_MENU_SELECTOR = '[data-mobile-menu-menu]';
var MOBILE_SUBMENU_CONTAINER = exports.MOBILE_SUBMENU_CONTAINER = '[data-mobile-submenu]';
var MOBILE_SUBMENU_TOGGLE = exports.MOBILE_SUBMENU_TOGGLE = '[data-mobile-submenu-toggle]';
var MOBILE_MENU_SUBMENU_BACK = exports.MOBILE_MENU_SUBMENU_BACK = '[data-mobile-submenu-back]';
var MOBILE_MENU_SUBSUBMENU = exports.MOBILE_MENU_SUBSUBMENU = '[data-mobile-subsubmenu]';
var MOBILE_SUBSUBMENU_TOGGLE = exports.MOBILE_SUBSUBMENU_TOGGLE = '[data-mobile-subsubmenu-toggle]';
var MOBILE_MENU_SUBSUBMENU_BACK = exports.MOBILE_MENU_SUBSUBMENU_BACK = '[data-mobile-subsubmenu-back]';

var MOBILE_MENU_SUBMENU_HANDLE = exports.MOBILE_MENU_SUBMENU_HANDLE = 'data-mobile-submenu-handle';

var CLASS_MENU_OPEN = exports.CLASS_MENU_OPEN = 'is-menu-open';
var CLASS_ACTIVE = exports.CLASS_ACTIVE = 'is-active';
var CLASS_FIXED = 'is-fixed';

var MobileMenu = exports.MobileMenu = function () {
  function MobileMenu(template, container) {
    var _this = this;

    (0, _classCallCheck3.default)(this, MobileMenu);

    this.container = container;

    this.menuTargets = [container, $('html,body'), $(MOBILE_MENU_BACKDROP)];

    this.submenuToggle = container.find(MOBILE_SUBMENU_TOGGLE);
    this.menu = container.find(MOBILE_MENU_MENU_SELECTOR);
    this.body = $('body');
    this.headerInner = template.find(_Header.HEADER_INNER);
    // this.backdrop = $(MOBILE_MENU_BACKDROP);.

    this.submenu = container.find(MOBILE_SUBMENU_CONTAINER);
    this.subsubmenu = container.find(MOBILE_MENU_SUBSUBMENU);
    this.mobileMenuToggle = template.find(MOBILE_MENU_TOGGLE);

    $(document).on('click touch', MOBILE_MENU_CLOSE, function (e) {
      return _this.close(e);
    });
    template.on('click touch', MOBILE_MENU_TOGGLE, function (e) {
      return _this.onMenuToggle(e);
    });
    $(window).on('resize orientationchange', function () {
      return _this.onResize();
    });
    container.on('click touch', MOBILE_SUBMENU_TOGGLE, function (e) {
      return _this.onSubmenuToggle(e);
    });
    container.on('click touch', MOBILE_MENU_SUBMENU_BACK, function (e) {
      return _this.onSubmenuBack(e);
    });
    container.on('click touch', MOBILE_SUBSUBMENU_TOGGLE, function (e) {
      return _this.onSubsubmenuToggle(e);
    });
  }

  (0, _createClass3.default)(MobileMenu, [{
    key: 'open',
    value: function open() {
      var _this2 = this;

      this.mobileMenuToggle.addClass(CLASS_ACTIVE);
      this.menuTargets.forEach(function (e) {
        return e.addClass(CLASS_MENU_OPEN);
      });
      //Show the logo after a tiny delay to await for RAF to finish.
      this.headerInner.removeClass(_Header.CLASS_DOWN);
      setTimeout(function () {
        return _this2.checkHeader();
      }, 50);

      //Set the height of the screen to prevent background scrolling
      // let vpH = $(window).innerHeight();
      // setTimeout(() => { this.body.css('height', `${vpH.toString()}px`); }, 500);
      $('body, html').addClass(CLASS_FIXED);
    }
  }, {
    key: 'checkHeader',
    value: function checkHeader() {
      var _this3 = this;

      if (!this.headerInner.hasClass(_Header.CLASS_DOWN)) {
        clearInterval(this.headerInt);
        return;
      }
      this.headerInner.removeClass(_Header.CLASS_DOWN);
      setTimeout(function () {
        return _this3.checkHeader();
      }, 100);
    }
  }, {
    key: 'close',
    value: function close() {
      this.mobileMenuToggle.removeClass(CLASS_ACTIVE);
      this.menuTargets.forEach(function (e) {
        return e.removeClass(CLASS_MENU_OPEN);
      });
      // this.body.css('height', '');
      this.submenu.removeClass(CLASS_ACTIVE);
      this.subsubmenu.removeClass(CLASS_MENU_OPEN);
      this.menu.addClass(CLASS_ACTIVE);
      $('body, html').removeClass(CLASS_FIXED);
    }
  }, {
    key: 'toggleOpen',
    value: function toggleOpen() {
      if (this.container.hasClass(CLASS_MENU_OPEN)) return this.close();

      this.open();
    }
  }, {
    key: 'onMenuToggle',
    value: function onMenuToggle(e) {
      this.cancelEvents(e) && this.toggleOpen();
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      if ($(window).width() < ResponsiveSizes.medium) return;

      if (this.body.hasClass(CLASS_MENU_OPEN)) {
        this.close();
        this.menuTargets.forEach(function (e) {
          return e.removeClass(CLASS_MENU_OPEN);
        });
        this.body.css('height', '');
      }
    }
  }, {
    key: 'onSubmenuToggle',
    value: function onSubmenuToggle(e) {
      this.cancelEvents(e);
      var subToggle = $(e.currentTarget);
      var handle = subToggle.attr(MOBILE_MENU_SUBMENU_HANDLE);
      var submenu = this.container.find('[' + MOBILE_MENU_SUBMENU_HANDLE + '="' + handle + '"]');
      if (!submenu.length) return;

      this.menu.removeClass(CLASS_ACTIVE);
      submenu.addClass(CLASS_ACTIVE);
    }
  }, {
    key: 'onSubsubmenuToggle',
    value: function onSubsubmenuToggle(e) {
      this.cancelEvents(e);
      var subToggle = $(e.currentTarget);

      var subsubMenu = subToggle.next(MOBILE_MENU_SUBSUBMENU);
      if (!subsubMenu.hasClass(CLASS_MENU_OPEN)) {
        subsubMenu.addClass(CLASS_MENU_OPEN);
      } else {
        subsubMenu.removeClass(CLASS_MENU_OPEN);
      }
    }
  }, {
    key: 'onSubmenuBack',
    value: function onSubmenuBack(e) {
      this.cancelEvents(e);
      this.submenu.removeClass(CLASS_ACTIVE);
      this.menu.addClass(CLASS_ACTIVE);
    }
  }, {
    key: 'cancelEvents',
    value: function cancelEvents(e) {
      e.preventDefault(), e.stopPropagation();
      return true;
    }
  }]);
  return MobileMenu;
}();